import React from "react";

export const ButtonArrow: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.138"
      height="14.792"
      viewBox="0 0 21.138 14.792"
    >
      <path
        data-name="Black arrow"
        d="M41.138,36.4a.752.752,0,0,1-.187.484l-6.341,6.694a.709.709,0,0,1-1,.028.732.732,0,0,1-.028-1l5.207-5.5H20.7a.7.7,0,0,1,0-1.409H38.793l-5.207-5.5a.743.743,0,0,1,.028-1,.715.715,0,0,1,1,.028l6.341,6.694a.642.642,0,0,1,.187.484Z"
        transform="translate(-20 -29.006)"
      />
    </svg>
  );
};
